export default __webpack_public_path__ + "static/media/Profile-pic-1.56af2aec.jpg";